<template>
    <button
        :disabled="active ? false : true"
        :class="active ? class_b : class_b + ' Mui-disabled'"
        class="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedFocus.90 MuiButton-sizeMedium MuiButton-containedSizeMedium MuiButton-disableElevation MuiButton-fullWidth MuiButton-root MuiButton-contained MuiButton-containedFocus.90 MuiButton-sizeMedium MuiButton-containedSizeMedium MuiButton-disableElevation MuiButton-fullWidth button-bottom"
        tabindex="0" type="button" role="button" data-testid="screen-next" v-html="text">
    </button>
</template>
<script>
	export default {
	    props: ['active', 'text', 'class_b'],
	}
</script>
